import { Routes } from '@angular/router';
import { Home } from './home/home';
import { authGuard } from './shared/services/auth.guard';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { regionValidatorGuard } from './shared/services/region.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    title: 'Home Page',
    canActivate: [],
    component: Home,
  },
  {
    path: 'providersTracking/:region',
    title: 'Providers Tracking',
    canActivate: [authGuard, regionValidatorGuard],
    loadComponent: () =>
      import('./providers-tracking/providers-tracking').then((m) => m.ProvidersTracking),
  },
  {
    path: 'unauthorized',
    title: 'Unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];
